import { Dispatch, SetStateAction } from "react";
import { ITableModel } from "components/Table/interface";
import { HealthOperatorProps } from "models/HealthOperator";

export interface TableItemsDataIntegrationProps {
  model: Array<ITableModel>;
  dataIntegration: HealthOperatorProps;
  setIsEditBuyOrder: Dispatch<SetStateAction<boolean>>;
  isEditBuyOrder: boolean;
}

export interface DataIntegrationItemProps {
  id: string;
  number: number;
  code: any;
  message: string;
  description: string;
  eventDate: Date;
}

export const StatusDisabledPurchasedOrder: string[] = [
  "ERROR_SENT_RECEIPT",
  "PENDING_RECEIPT",
  "SENT_RECEIPT",
  "FINISHED",
  "SENT_INVOICE"
];

export const statusEnableFinalizeIntegration = [
  "MANUAL_ACTION_REQUIRED"
];